export const Optional = (predicate, positive, negative = null) => {
    return predicate ? positive : negative;
};
